import axios from 'axios'
import { WX_HOSTNAME } from 'common/utils/variables'
import { inWechat, isWeCom, isMiniBankInsurance } from './config'
import { getUrlParam, getUrlByAddingParam } from 'common/js/common'

const checkUrl = `${WX_HOSTNAME}/box/wx/checkUserInfoExists`

export default async ({ token, wxMpAppid, componentAppid }) => {
  if (!inWechat || isWeCom || isMiniBankInsurance) {
    return Promise.resolve()
  }
  // returnUrl
  // 在分享时已经带上
  // {
  //   wxMpAppid: wxMpAppid,
  //   component_appid: componentAppid
  // }
  // ZYFN-7214, 隐藏来源分享在微信中打开时，上述假设不正确，此处做设置但不覆盖
  let returnUrl = getUrlByAddingParam({ token }, location.href)
  returnUrl = getUrlByAddingParam({ wxMpAppid }, returnUrl)
  if (componentAppid) {
    returnUrl = getUrlByAddingParam({ component_appid: componentAppid }, returnUrl)
  }
  const redirectUrl = `${WX_HOSTNAME}/box/wx/authorizeUserInfoWithCode?return_url=${encodeURIComponent(returnUrl)}`
  const oauthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxMpAppid}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`

  try {
    const { data: { code } } = await axios
      .create()
      .get(checkUrl, {
        params: {
          token,
          appId: wxMpAppid
        }
      })
    if (code !== 400 || getUrlParam('autoOauth') != '') {
      return Promise.resolve(true)
    }
    location.replace(oauthUrl)
  } catch (error) {
    console.log('[OAUTH]', error)
  }
}
